import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=e619b1cc&scoped=true"
import script from "./IntegrationCard.vue?vue&type=script&lang=js"
export * from "./IntegrationCard.vue?vue&type=script&lang=js"
import style0 from "./IntegrationCard.vue?vue&type=style&index=0&id=e619b1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e619b1cc",
  null
  
)

export default component.exports